import { useEffect, useMemo } from "react";
import { matchPath, useLocation } from "react-router-dom";

import { Routes } from "constants/routes";
import { useNavigationHooks, useUrlHooks } from "hooks";
import { isEqual } from "lodash";
import { useCorrelationMatrixSettingsSelector } from "store";
import { CorrelationMatrixSettings, ToJsonString } from "store/types";
import rmEmptyFields from "utils/rm-empty-fields";

import { defaultCorrelationMatrixSettings } from "../../constants";

export const useCorrelationMatrixQueries = () => {
  const { setParams, removeParams } = useNavigationHooks();
  const { queryParams } = useUrlHooks();
  const { pathname } = useLocation();
  const correlationSettingsStorage = useCorrelationMatrixSettingsSelector();

  const correlationSettingsURL = useMemo(() => queryParams.correlationMatrixSettings, [queryParams]);
  const clearedSettingsStorage = useMemo(() => rmEmptyFields(correlationSettingsStorage), [correlationSettingsStorage]);

  const isDefaultParameters = useMemo(() => {
    return isEqual(clearedSettingsStorage, rmEmptyFields(defaultCorrelationMatrixSettings));
  }, [clearedSettingsStorage]);

  useEffect(() => {
    // Remove correlation matrix settings when outside the Benchmark correlation page if they are in the URL
    if (correlationSettingsURL && !matchPath(pathname, Routes.benchmarkCorrelation)) {
      return removeParams(["correlationMatrixSettings"]);
    }

    if (matchPath(pathname, Routes.benchmarkCorrelation)) {
      if (isDefaultParameters) {
        return removeParams(["correlationMatrixSettings"]);
      }

      setParams({
        search: {
          correlationMatrixSettings: JSON.stringify({
            ...clearedSettingsStorage
          }) as ToJsonString<CorrelationMatrixSettings>
        }
      });
    }
  }, [clearedSettingsStorage, pathname]);
};
